import { Dispatch, Middleware } from "redux";

import { AppInsights } from "applicationinsights-js";

import { getFeatureToggles } from "../getFeatureToggles";
import * as FeatureToggleNames from "../featureToggleNames";

import { getProperties } from "./getProperties";
import { trackPageView } from "./appInsightsSetup";

import { LOCATION_CHANGED, LocationChangedAction } from "redux-little-router";

const useAppInsightsConnectionString = getFeatureToggles()[FeatureToggleNames.UseAppInsightsConnectionString];

const appInsightsTrackPageViewMiddlewareNew: Middleware = () => (next: Dispatch<LocationChangedAction>) => async (action: LocationChangedAction) => {
    const result = await next(action);

    if (action.type === LOCATION_CHANGED) {
        const routeResult = (action.payload || {}).result;

        if (routeResult) {
            trackPageView({
                name: routeResult.title,
                uri: routeResult.pathname,
                properties: getProperties()
            });
        }
    }
    return result;
};

const appInsightsTrackPageViewMiddlewareOld: Middleware = () => (next: Dispatch<LocationChangedAction>) => async (action: LocationChangedAction) => {
    const result = await next(action);

    if (action.type === LOCATION_CHANGED) {
        const routeResult = (action.payload || {}).result;

        if (routeResult) {
            AppInsights.trackPageView(routeResult.title, routeResult.pathname, getProperties());
        }
    }
    return result;
};

export const appInsightsTrackPageViewMiddleware: Middleware = useAppInsightsConnectionString
    ? appInsightsTrackPageViewMiddlewareNew
    : appInsightsTrackPageViewMiddlewareOld;
